










import Vue from 'vue'
import {COLOR_STATO_CHIUSA, COLOR_STATO_IN_CARICO} from '../../costanti_report'

export default Vue.extend({
    data: () => ({
        COLOR_STATO_IN_CARICO,
        COLOR_STATO_CHIUSA
    })
})
